import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { Mg68 } from './mg68'

export class Mg68ACE_UpPlus extends Mg68 {
  name: string = 'MG68_Plus'
  icon: string = list_icon
  width: number = 710
}
